import { useState, useEffect } from "react";
import { Box, SpaceBetween, Header } from "@cloudscape-design/components";
import AccountSettingsNavigation from 'components/AccountSettingsComponents/AccountSettingsNavigation';
import SecurityTab from '../components/AccountSettingsComponents/SecurityTab';
import ProfileTab from "../components/AccountSettingsComponents/ProfileTab";
import { useBreadcrumbs } from "contexts/BreadcrumbContext";
import "../styles/common.css";
// Placeholder components for other tabs
const DeviceActivityTab = () => <div>Device Activity Content Coming Soon</div>;
const LinkedAccountsTab = () => <div>Linked Accounts Content Coming Soon</div>;

export default function AccountSettings() {
    const { setBreadcrumbs } = useBreadcrumbs();
    const [activeTab, setActiveTab] = useState('#/profile');
    const handleHashChange = () => {
            setActiveTab(window.location.hash || '#/profile');
        };

    useEffect(() => {
        setBreadcrumbs([
            { text: "Aswar Menu", href: "/" },
            { text: "Account Settings", href: "/account-settings" }
        ]);
    }, []);

    useEffect(() => {

        const pendingTab = window.sessionStorage.getItem('profile.activeTab');
        if (pendingTab) {
            window.sessionStorage.removeItem('profile.activeTab');
            window.location.hash = pendingTab;
        } else if(!window.location.hash){
            window.location.hash = "#/profile";
        }
        
        window.addEventListener('hashchange', handleHashChange);
        // Set initial tab
        setActiveTab(window.location.hash || '#/profile');

        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    const renderTabContent = () => {
        switch (activeTab) {
            case '#/profile':
                return <ProfileTab />;
            case '#/security':
                return <SecurityTab />;
            case '#/device-activity':
                return <DeviceActivityTab />;
            case '#/linked-accounts':
                return <LinkedAccountsTab />;
            default:
                return <ProfileTab />;
        }
    };

    return (
        <Box>
            <SpaceBetween size="l">
                <Header variant="h2">Account Settings</Header>
                <p>Manage your personal account settings and preferences.</p>
                <div className='profile-wrapper'>
                    <AccountSettingsNavigation />
                    <div className='profile-content'>
                        {renderTabContent()}
                    </div>
                </div>
            </SpaceBetween>  
        </Box>
    );
}
